import React from "react";

export const highlightText = (text, searchTerm) => {
  if (!searchTerm) return text;

  const regex = new RegExp(`(${searchTerm})`, "gi");
  return text?.split(regex).map((part, index) =>
    regex.test(part) ? (
      <span
        key={index}
        style={{
          backgroundColor: "#3498db",
          color: "white",
          fontWeight: "bold",
          padding: ".1em",
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

export function hasAdminType(data) {
  if (!Array.isArray(data)) return false;
  return data.some(item =>
    item.Type?.toLowerCase() === "clientadmin" &&
    String(item.isUserInGroup).toLowerCase() === "true"
  );
}

export function getApplicableFilterCount(filters, templateId) {
  if (!Array.isArray(filters) || !templateId) return 0;

  return filters.filter(f => 
    Array.isArray(f.templateIds) && f.templateIds.includes(templateId)
  ).length;
}

export const Logos = {
  MINERVA_LOGO: "https://stminervaclouddev.blob.core.windows.net/images-store/minerva-logo.png",
  GENERICDOC_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/genericDoc.png",
  ADOBE_PDF_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/adobe-pdf-icon.webp",
  EMAIL_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/emailicon.png",
  EXCEL_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/excel.png",
  PDF_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/pdf.png",
  WORD_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/word.png",
  PPT_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/ppt.png",
  IMAGE_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/image.png"
}